import { errorHandler } from "@/services/toastHandler";

const SETTING = { section: "system", key: "bet-placed-alert-config" };

const betPlacedAlertConfigModule = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
  },
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },
  actions: {
    async getBetPlacedAlertConfig({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: SETTING,
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    // value: { enabled: boolean, liabilityThreshold: number }
    async updateBetPlacedAlertConfig({ commit }, value) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          ...SETTING,
          value,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default betPlacedAlertConfigModule;
